const dashboardClockSelector = "[data-dashboard-clock]";
const dashboardDateSelector = "[data-dashboard-current-date]";

const updateDashboardClock = () => {
  const clock = document.querySelector(dashboardClockSelector);
  const date = document.querySelector(dashboardDateSelector);
  if (!clock && !date) return;

  const timezone = clock?.dataset.timezone || "Australia/Sydney";
  const now = new Date();

  if (clock) {
    clock.textContent = new Intl.DateTimeFormat("en-AU", {
      timeZone: timezone,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false
    }).format(now);
  }

  if (date) {
    date.textContent = new Intl.DateTimeFormat("en-AU", {
      timeZone: timezone,
      weekday: "long",
      day: "2-digit",
      month: "short",
      year: "numeric"
    }).format(now);
  }
};

const startDashboardClock = () => {
  updateDashboardClock();

  if (window.dashboardClockInterval) {
    window.clearInterval(window.dashboardClockInterval);
  }

  window.dashboardClockInterval = window.setInterval(updateDashboardClock, 1000);
};

document.addEventListener("DOMContentLoaded", startDashboardClock);
